import { render, staticRenderFns } from "./volunteer.vue?vue&type=template&id=b671ae16&scoped=true&"
import script from "./volunteer.vue?vue&type=script&lang=js&"
export * from "./volunteer.vue?vue&type=script&lang=js&"
import style0 from "./volunteer.vue?vue&type=style&index=0&id=b671ae16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b671ae16",
  null
  
)

export default component.exports